import React from "react";
import { ColumnProps } from "antd/lib/table/interface";
import { InvigilationStuListItem } from "../../../../../../../service/exam";
import styles from "./index.module.scss";
import { Table, Tooltip } from "antd";
import TooltipUl from "../../../../../../../components/TooltipUl";

interface Props {
    data: InvigilationStuListItem[];
    rowSelection: any;
    onSelect: (item: InvigilationStuListItem) => void;
}
const Index = ({ data, rowSelection, onSelect }: Props) => {
    const columns: ColumnProps<InvigilationStuListItem>[] = [
        {
            title: "考生信息",
            width: 120,
            render: (_, item) => (
                <div className={styles.student}>
                    {item.studentName} <span>{item.studentNo}</span>
                </div>
            )
        },
        {
            title: "课程信息",
            ellipsis: true,
            render(text, item) {
                return (
                    <Tooltip
                        placement="topLeft"
                        title={`${item.courseName}[${item.courseNo}-${item.courseSeq}]`}>
                        {`${item.courseName}[${item.courseNo}-${item.courseSeq}]`}
                    </Tooltip>
                );
            }
        },
        // {
        //     title: "授课老师",
        //     dataIndex: "lectureTeacherName",
        //     ellipsis: true,
        //     render: (text, item) => {
        //         return (
        //             <Tooltip
        //                 placement="topLeft"
        //                 title={<TooltipUl data={text} />}>
        //                 {text}({item.lectureTeacherId})
        //             </Tooltip>
        //         );
        //     }
        // },
        // {
        //     title: "主监考",
        //     dataIndex: "masterTeacherName",
        //     ellipsis: true,
        //     render: (text, item) => {
        //         return (
        //             <Tooltip
        //                 placement="topLeft"
        //                 title={<TooltipUl data={text} />}>
        //                 {text}({item.masterTeacherId})
        //             </Tooltip>
        //         );
        //     }
        // },
        {
            title: "监考",
            dataIndex: "assistantTeacherName",
            ellipsis: true,
            render: text => {
                return (
                    <Tooltip
                        placement="topLeft"
                        title={<TooltipUl data={text} />}>
                        {text}
                    </Tooltip>
                );
            }
        },
        {
            title: "考场信息",
            dataIndex: "meetingRoom",
            ellipsis: true,
            render: text => {
                return (
                    <Tooltip
                        placement="topLeft"
                        title={<TooltipUl data={text} />}>
                        {text}
                    </Tooltip>
                );
            }
        },
        {
            title: "机房",
            dataIndex: "machineRoomName"
        },
        {
            title: "IP池范围",
            dataIndex: "ipRange"
        }
    ];

    return (
        <div className={styles.root}>
            <Table
                rowSelection={rowSelection}
                size="small"
                rowKey="detailId"
                pagination={false}
                scroll={{
                    y: "400px"
                }}
                onRow={(record, index) => ({
                    onClick: () => onSelect(record)
                })}
                columns={columns}
                dataSource={data}
            />
        </div>
    );
};

export default Index;
